export default __webpack_public_path__ + "static/media/Y_Ybytu.6e5e9038.svg";